import { render, staticRenderFns } from "./SignupSex.vue?vue&type=template&id=283ad72f&scoped=true&"
import script from "./SignupSex.vue?vue&type=script&lang=js&"
export * from "./SignupSex.vue?vue&type=script&lang=js&"
import style0 from "./SignupSex.vue?vue&type=style&index=0&id=283ad72f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283ad72f",
  null
  
)

export default component.exports